import type { NextPage } from 'next'

const RulePage: NextPage = () => {
  return <div>{/* TODO: 利用規約ページを実装する */}</div>
}

export default RulePage

export { getStaticPaths, getStaticProps } from '@/components/Functional/utils/getStaticFunctions'
